module.exports = __webpack_public_path__ + "static/media/logow.b55142d1.png";